// @TODO: Look into what can be hoisted here

import { NextPage, GetServerSideProps } from 'next'
import { SSRConfig } from 'next-i18next'

export * from './auth'
export * from './convergence'
export * from './country'
export * from './state'
export * from './dispute'
export * from './cardScan'
export * from './identity'
export * from './consumer'

// Rely on types and helpers provided by '@afterpaytouch/portal-api'

export type ConsumerPage<T = {}> = NextPage<T & SSRConfig> & {
  getLayout?: (page: any) => JSX.Element
}

export * from '@afterpaytouch/portal-api'

export type ConsumerProps<T> = T & SSRConfig

export type GetConsumerSSP<T = {}> = GetServerSideProps<ConsumerProps<T>>
